import React from 'react';
import { Settings } from '@pascal/pascal-core/table-line';
import { useTranslation } from '@pascal/pascal-core';
import { observer } from 'mobx-react-lite';
import { CARD_BACKSIDE_TYPES } from '../../enums/cardTypes';
import { cardsStore } from '../../store/cardsStore';

export const SettingsContainer = observer(() => {
  const { selectedCardType, setSelectedCardType } = cardsStore;
  const t = useTranslation();
  return (
    <>
      <Settings />
      <div className='settings-cards-section'>
        <div className='settings-cards-section-inner'>
          <span className='settings-cards-section-txt'>{t('CARDS')}</span>

          {CARD_BACKSIDE_TYPES.map((cardType, index) => {
            if (!(index % 2)) {
              return (
                <div className='settings-cards-holder' key={cardType}>
                  <div
                    className={`settings-cards-container ${
                      selectedCardType === cardType ? 'active' : ''
                    }`}
                    onClick={() => setSelectedCardType(cardType)}
                  >
                    <div className={`settings-cards ${cardType} h-A`} />
                    <div className={`settings-cards ${cardType} d-A`} />
                    <div className={`settings-cards ${cardType} p-A`} />
                    <div className={`settings-cards ${cardType} c-A`} />
                  </div>
                  <div
                    className={`settings-cards-container ${
                      selectedCardType === CARD_BACKSIDE_TYPES[index + 1] ? 'active' : ''
                    }`}
                    onClick={() => setSelectedCardType(CARD_BACKSIDE_TYPES[index + 1])}
                  >
                    <div className={`settings-cards ${CARD_BACKSIDE_TYPES[index + 1]} h-A`} />
                    <div className={`settings-cards ${CARD_BACKSIDE_TYPES[index + 1]} d-A`} />
                    <div className={`settings-cards ${CARD_BACKSIDE_TYPES[index + 1]} p-A`} />
                    <div className={`settings-cards ${CARD_BACKSIDE_TYPES[index + 1]} c-A`} />
                  </div>
                </div>
              );
            }
            return null;
          })}
        </div>
      </div>
    </>
  );
});
